module.exports = __webpack_public_path__ + "fonts/EBGaramond-Roman-VariableFont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/EBGaramond/EBGaramond-Roman-VariableFont.ttf
// module id = 3490
// module chunks = 0